const urlUtilities = {
  replaceUrlParamWildcard: (url: string, param: string, value: string): string => {
    if (!url) {
      return '';
    }
    const newUrl = new URL(url);

    let paramFound: boolean = false;
    newUrl.searchParams.forEach((paramValue, paramName) => {
      if (paramName.indexOf(param) !== -1) {
        newUrl.searchParams.set(paramName, value);
        paramFound = true;
        return;
      }
    });

    return paramFound ? newUrl.toString() : url;
  }
}

export default urlUtilities;
